import React, { useEffect } from 'react';
import ApiValidationErrorDisplay from '~/components/ApiValidationErrorDisplay';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { schema } from './swapEffect.yup';
import DisplayFormikState from '~/components/DisplayFormikState';
import SubmitResetButtons from '~/components/FormControl/SubmitResetButtons';
import classNames from 'classnames/bind';
const cx = classNames.bind();
import { FormText, FormSelect, TextArea, Selectize, FormNumber } from '~/components/FormControl';
import { Formik } from 'formik';
import { Card, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { FileUploadedWithResetCount } from '~/components/FileUploaded';
import { useNavigate } from 'react-router-dom';
import { fetchCardMetaDataApi } from '~/pages/CardSaga/cardMetaDataSlice';
import { ITEMS } from '~/config/constants';

SwapEffectForm.defaultProps = {
    pictureAttributeNames: null,
};
SwapEffectForm.propTypes = {
    initialValues: PropTypes.object.isRequired,
    setResetCount: PropTypes.func.isRequired,
    pictureAttributeNames: PropTypes.array,
    resetCount: PropTypes.number.isRequired,
    formSubmit: PropTypes.func.isRequired,
};

function SwapEffectForm({ initialValues, setResetCount, pictureAttributeNames, resetCount, formSubmit }) {
    const { isLoading } = useSelector((state) => state.loading);
    const { apiValidationErrors } = useSelector((state) => state.apiValidationError);

    const { cardMetaData } = useSelector((state) => state.cardSaga.cardMetaData);
    const { actions, powers, upgrades, characterClasses } = cardMetaData;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (isEmpty(cardMetaData)) {
            dispatch(fetchCardMetaDataApi(navigate));
        }
    }, []);

    return (
        <>
            {/* MUST put `isEmpty(swapEffectMetaData)` in condition, else Bootstrap `Select` will not display value to UI (even though it's already stored value in it)  */}
            {!isEmpty(initialValues) && !isEmpty(cardMetaData) ? (
                <Card>
                    <Card.Body>
                        <Formik
                            initialValues={initialValues}
                            validateOnChange={false}
                            validationSchema={initialValues.id === null ? schema : schema(true)}
                            onSubmit={formSubmit}
                        >
                            {(props) => {
                                // eslint-disable-next-line react/prop-types
                                const { handleSubmit, isSubmitting, resetForm, values } = props;

                                return (
                                    <>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <Form.Row className="d-flex justify-content-between">
                                            <TextArea
                                                name={'description'}
                                                sm={3}
                                                rows={4}
                                            />
                                        </Form.Row>

                                        <Form.Row className="mt-3">
                                            <FormText
                                                name={'action_quantity'}
                                                label="Quantity action card to swap"
                                                sm={3}
                                            />
                                            <Selectize
                                                name="action_id"
                                                options={[...actions, ...powers]}
                                                sm={3}
                                                label="Action"
                                            />
                                            <FormNumber
                                                name={'upgrade_quantity'}
                                                label="Quantity upgrade card to receive"
                                                sm={3}
                                            />
                                            <FormSelect
                                                name="upgrade_id"
                                                options={[...powers, ...upgrades]}
                                                sm={3}
                                                label="Upgrade"
                                            />

                                        </Form.Row>
                                        <SubmitResetButtons
                                            isSubmitting={isSubmitting}
                                            handleSubmit={handleSubmit}
                                            setResetCount={setResetCount}
                                            resetForm={resetForm}
                                        />
                                        <ApiValidationErrorDisplay
                                            errors={apiValidationErrors}
                                            clearError={clearApiValidationErrors}
                                        />
                                        <DisplayFormikState props={props} />
                                    </>
                                );
                            }}
                        </Formik>
                    </Card.Body>
                </Card>
            ) : (
                <Card style={{ position: 'relative' }}>
                    <Card.Body className={cx('row', { whirl: isLoading })}></Card.Body>
                </Card>
            )}
        </>
    );
}

export default SwapEffectForm;
